<template>
    <v-tabs
        v-model="currentNavigationItemIndex"
        align-with-titles
        :show-arrows="!$vuetify.breakpoint.xsOnly"
        center-active
    >
        <NavigationItem
            v-for="(navigationItem, index) in navigationItemList" 
            :key="`navigation-${navigationItem.id}-${index}`"
            :data="data"
            :index="index"
            :navigationItem="navigationItem"
            @selectNavigationItem="selectNavigationItem"
            @selectNavigationItemMenu="selectNavigationItemMenu"
        />
    </v-tabs>
</template>

<script>
    import NavigationItem from '@/layout/alternative/layout/components/NavigationItem.vue';

    export default {
        name: "Navigation",
        props: {
            data: {
                type: Object,
                required: true
            },
            navigationItemList: {
                type: Array,
                required: true
            },
        },
        components:{
            NavigationItem,
        },
        data: () => ({
            currentNavigationItemIndex: 0,
        }),
        mounted() {
            if(this.navigationItemList) {
                this.updateNavigationItemIndex();
            }
        },
        methods: {
            updateNavigationItemIndex(){
                this.currentNavigationItemIndex = this.navigationItemList.findIndex(item => item.active === true);
            },
            selectNavigationItem(item, index){
                this.$emit('selectNavigationItem', item, index);
            },
            selectNavigationItemMenu(item, subItem) {
                this.$emit('selectNavigationItemMenu', item, subItem);
                this.updateNavigationItemIndex();
            }
        },  
        watch:{
            '$props.data'(val){
                if (val) {
                    this.updateNavigationItemIndex();
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/layout/alternative/layout/components/Navigation.vue